import React, { Suspense } from 'react';
import { DefaultMetricOptions } from 'shared/types/metric-template';

import { GoalInsightsMetricEntriesCard } from './goal-insights-metric-entries-card';
import { GoalInsightsSubGoalCard } from './goal-insights-sub-goal-card';
import { GoalInsightsTaskCard } from './goal-insights-task-card';
import { LoadingInsightsCard } from './loading-insights-card';
import { GoalInsightsCardProps } from './types';

export const GoalInsightsCard: React.FC<GoalInsightsCardProps> = ({
  goal,
  ...rest
}) => {
  if (!goal.metric || goal.metric.id === DefaultMetricOptions.CompletedTasks) {
    return (
      <Suspense fallback={<LoadingInsightsCard goal={goal} />}>
        <GoalInsightsTaskCard goal={goal} {...rest} />
      </Suspense>
    );
  }

  if (goal.metric.id === DefaultMetricOptions.SubGoalProgress) {
    return (
      <Suspense fallback={<LoadingInsightsCard goal={goal} />}>
        <GoalInsightsSubGoalCard goal={goal} {...rest} />
      </Suspense>
    );
  }

  return <GoalInsightsMetricEntriesCard goal={goal} {...rest} />;
};
